import { Checkbox, DefaultButton, Label, List, PrimaryButton, Stack, TextField , Image} from "@fluentui/react"
import { CabeceraTable } from "../../components/Table/CabeceraTable"
import { UseFormularioHazard } from "./UseFormularioHazard"
import { ComboBoxComponent } from "../../components/comboBox/ComboBoxComponent"
import { Caption1Strong, Card } from "@fluentui/react-components"
import ComboBoxDef from "../../components/comboBox/ComboxBoxDef"
import React, { ReactNode, useState } from "react"
import { IItemComboBaseDTO } from "../../Interfaces/base/IBase"
import { PanelFooter } from "../../components/Panel/PanelFooter"
import { PanelHazardConfirmacion } from "./HazardConfirmacion/PanelHazardConfirmacion"
import { useBoolean } from "@fluentui/react-hooks";
import { Body1, makeStyles } from "@fluentui/react-components";
import { UseComboGeneric } from "../../hooks/hazard/combo/UseComboGeneric"
import { ElementoEstandarService } from "../../services/hazard/elementoEstandarService"
import { Ifilter } from "../../Interfaces/filter"

export const FormularioHazard=()=>{
    const {request,setRequest,incidentes,condiciones,actos,handleCardClick,niveles,ubicaciones,empresas,hazardPersona,
        handlenivelClick,requestUbicacion,setRequestUbicacion,acordados,handleAcordadoClick} = UseFormularioHazard()
    const [isOpenConfirmacion, { setTrue: openPanelConfirmacion, setFalse: closePanelConfirmacion }] = useBoolean(false);
    const [filter, setFilter] = useState<Ifilter>({
      skip: 0,
      take: 20,
      search: ""
  });
    const comboElementos = UseComboGeneric({isOpen:true,filter:filter,
      setFilter:setFilter,fetchData:ElementoEstandarService.ComboElementoEstandar});

    return(
        <>
        <CabeceraTable Titulo={"Hazard"} SubTitulo={"Formulario de Incidentes"}/>
       
        <div style={{padding:'10px 100px'}}>
        <div style={{borderRadius:'12px', boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
        backgroundColor:'#B52323',padding:'20px 40px'}}>
        <h1 style={{color:'white'}}>Reporte de Peligros</h1>
        <Image/>
        </div>
        <br/>
        
        <div style={{borderRadius:'4px', boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
        backgroundColor:'#EBF2F6',padding:'20px 40px'}}>
        <Label>Grupo Incidente</Label>
        <div style={{display:'flex',flexWrap:'wrap',justifyContent:'center',
        gap: '1rem'}}>
        {incidentes && incidentes.map((item,index)=>(
          <div  style={{backgroundColor:request.incidenteId==item.key ? '#48bb78':'white',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: 16,
          maxWidth: 300,
          display:'flex',justifyContent:'space-between',
          alignItems:'center',cursor:'pointer',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}} onClick={()=>{handleCardClick(item.key)}}  key={index}>
          <Caption1Strong>{item.text}</Caption1Strong>
          </div>
        ))}
        </div>
        <TextField 
         type="text"
         label="Titulo"
         placeholder="Ingrese titulo"
         autoComplete="off"
         value={request.titulo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,titulo:newValue})}
         }}
         />
         <TextField 
         type="text"
         label="Descripción"
         placeholder="Ingrese descripción"
         autoComplete="off"
         value={request.descripcion}
         multiline
         rows={3}
         resizable={false}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,descripcion:newValue})}
         }}
         />
        <TextField 
         type="text"
         label="Acciones Inmediatas"
         placeholder="Ingrese Acciones Inmediatas"
         autoComplete="off"
         multiline
         rows={3}
         resizable={false}
         value={request.accionesInmediatas}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,accionesInmediatas:newValue})}
         }}
         />
         <TextField 
         type="text"
         label="Observaciones (Opcional)"
         placeholder="Ingrese Observaciones"
         autoComplete="off"
         multiline
         rows={3}
         resizable={false}
         value={request.observaciones}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,observaciones:newValue})}
         }}
         />
         <ComboBoxComponent
          text={"Elemento Estandar"}placeholder="Seleccione un Elemento Estandar"
          selectedKey={request.elementoEstandarId} data={comboElementos.dataCombo}
          onOptionSelect={(event, option) => {
            if (option!=undefined) {
              setRequest({...request,elementoEstandarId:option.key.toString()})}
           }}
           onChange={(value) => {
                 comboElementos.onChangeGeneric(value)
            }} />
         </div>
         <br/>


         <div style={{borderRadius:'4px', boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
        backgroundColor:'#EBF2F6',padding:'20px 40px'}}>
         <ComboBoxComponent
          text={"Ubicación"}placeholder="Seleccione un ubicación"
          selectedKey={request.ubicacionId} data={ubicaciones}
          onOptionSelect={(event, option) => {
            if (option!=undefined) {
              //onChangeCombo(event, option, "ubicacion");
              setRequest({...request,ubicacionId:option.key.toString()})}
            
           }}
           onChange={(value) => {
                 setRequestUbicacion({ ...requestUbicacion, search: value })
            }} />
            <TextField 
         type="text"
         label="Detalle de Ubicación"
         placeholder="Ingrese DetalleUbicación"
         autoComplete="off"
         multiline
         rows={3}
         resizable={false}
         value={request.descripcionUbicacion}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,descripcionUbicacion:newValue})}
         }}
         />
        <TextField 
         type="datetime-local"
         label="Cuando Ocurrio"
         placeholder="Ingrese fecha y hora"
         autoComplete="off"
         value={request.fecha}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,fecha:newValue})}
         }}
         />
            <br/>
            <Label >Tipo de Persona:       {hazardPersona.nombreTipo}</Label>
        
            <br/>
           </div>
           <br/>
              <div style={{display:'flex',justifyContent:'space-between',borderRadius:'4px', boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
                backgroundColor:'#EBF2F6',padding:'20px 40px'}}>
               <ComboBoxComponent text={"Condición Insegura"} data={condiciones} onOptionSelect={(event,option)=>{
                  if (option!=undefined) {
                     setRequest({...request,condicionId: option.key.toString()})
                  }}}/>
               <ComboBoxComponent text={"Acto Inseguro"} data={actos} onOptionSelect={(event,option)=>{
                  if (option!=undefined) {
                     setRequest({...request,actoId: option.key.toString()})
                  }}}/>
                  <ComboBoxComponent text={"Condición Insegura Secundaría"} data={condiciones} onOptionSelect={(event,option)=>{
                  if (option!=undefined) {
                     setRequest({...request,condicionSecundariaId: option.key.toString()})
                  }}}/>
               <ComboBoxComponent text={"Acto Inseguro Secundaria"} data={actos} onOptionSelect={(event,option)=>{
                  if (option!=undefined) {
                     setRequest({...request,actoSecundarioId: option.key.toString()})
                  }}}/>
             
      
        
              </div>
           
           <br/>

           <div style={{borderRadius:'4px', boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
        backgroundColor:'#EBF2F6',padding:'20px 40px'}}>
           <div style={{display:'flex',justifyContent:'space-between'}}>
           {niveles && niveles.map((item,index)=>(<div key={index} style={{display:'flex',flexDirection:'row',justifyContent:'space-between',
           border: '1px solid #ccc',
           borderRadius: '8px',
           padding: 16,
           maxWidth: 300,backgroundColor:'white',
           alignItems:'center',cursor:'pointer',
           boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
            <Label >{item.text}</Label>
              <div style={{paddingTop:'5px'}}>
              <Checkbox label='  ' key={index} boxSide="end" checked={request.nivelRiesgoId==item.key} onChange={(ev,checked)=>{
                if(checked==true){
                    handlenivelClick(item.key)
                }
              }}/>
              </div>
           </div>))}</div>
           <div style={{display:'flex',justifyContent:'space-between'}}>
           {acordados && acordados.map((item,index)=>(<div key={index} style={{display:'flex',flexDirection:'row',justifyContent:'space-between',
           border: '1px solid #ccc',
           borderRadius: '8px',
           padding: 16,
           maxWidth: 300,backgroundColor:'white',
           alignItems:'center',cursor:'pointer',
           boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
            <Label >{item.text}</Label>
              <div style={{paddingTop:'5px'}}>
              <Checkbox label='  ' key={index} boxSide="end" checked={request.nivelRiesgoAcordadoId==item.key} onChange={(ev,checked)=>{
                if(checked==true){
                  handleAcordadoClick(item.key)
                }
              }}/>
              </div>
           </div>))}</div>
           <br/>
           <TextField 
            type="text"   label="¿Por qué este nivel de riesgo?"
            placeholder="Ingrese la razón" autoComplete="off"
            multiline rows={3} resizable={false}
            value={request.razonRiesgo}
            onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,razonRiesgo:newValue})}
             }}/>
             <br/>
             <Label >Reportado por : {hazardPersona.nombre}</Label>
             <Label >Empresa:       {hazardPersona.empresa}</Label>
            
           </div>
         

            <br/>
            <div style={{display:'flex',justifyContent:'space-between'}}>
            <PrimaryButton text="Guardar" onClick={openPanelConfirmacion}/>
            <DefaultButton text="Cancelar"/>
            </div>
            <br/>
         
        </div>
        <PanelHazardConfirmacion request={request} isOpen={isOpenConfirmacion} onDismiss={closePanelConfirmacion}/>
           
           
           
        </>
    )
}